const transformContent = content =>
  Object.values(content).map(item =>
    item.menuItems
      ? { ...item, menuItems: Object.values(item.menuItems) }
      : item,
  );

export default transformContent;
